import { Box, Button, CircularProgress, MenuItem, TextField } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LoadingButton from "components/LoadingButton";
import { snack } from "components/toast";
import { Dispatch, SetStateAction, useState } from "react";
import { useMutation } from "react-query";
import { SubmitType } from "types";
import { createBillingEntity } from "api/services/billingEntity";
import { useNavigate } from "react-router-dom";
import { DesktopDatePicker } from "@mui/lab";
import { handleKeyDown } from "utils/keyDownPrevent";
import moment from "moment";
import { client_categories } from "views/signup/PanDetails";
import SafeTextField from "components/SafeTextField";

interface Props {
    setOpen: Dispatch<SetStateAction<boolean>>;
    onSuccess?: () => void;
}


const PanDetails = ({ setOpen, onSuccess }: Props) => {
    const [state, setState] = useState<any>({ showDiscount: 'true' });
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [forFocus, setForFocus] = useState(true);
    const navigate = useNavigate();
    const { mutate, isLoading } = useMutation(createBillingEntity, {
        onSuccess: (res) => {
            snack.success("Billing Entity Created");
            if (onSuccess) {
                onSuccess();
            } else {
                navigate(`/settings/billing-entities/${res?.data?.id}`);
            }
            setOpen(false);
        },

        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.name === 'panNumber') {
            const no = event.target.value.toUpperCase()
            setState(prevState => ({
                ...prevState,
                [event.target.name]: no
            }));
        } else {
            setState({ ...state, [event.target.name]: event.target.value });

        }
    };

    const handleSubmit = async (e) => {
        if (state.panNumber !== undefined && (state.panNumber.length !== 10 || !PAN_REGEX.test(state.panNumber))) {
            return snack.error("Invalid PAN Pattern");
        }
        if (!state.tradeName) return snack.error('Trade Name is required');
        if (!state.category) return snack.error('Constitution of Business is Required !');
        if (!state.registrationDate) return snack.error('Effective Date Of Registration is Required !');
        mutate({
            ...state,
            panVerified: true,
            category: state.category?.toUpperCase(),
            hasGst: false,
            registrationDate: state.registrationDate
        });

    };
    const PAN_REGEX = /^[A-Z]{3}[A,B,C,F,G,H,L,J,P,T]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/;

    const handleSelect = () => {
        setIsDatePickerOpen(false);
        setForFocus(false);
    };

    const handleFocus = () => {
        if (forFocus)
            setIsDatePickerOpen(true);
        setForFocus(true);
    };

    const isValidPan = (panNumber) => {
        return PAN_REGEX.test(panNumber);
    };

    return (
        <>
            <Box>
                <TextField
                    onChange={handleChange}
                    value={state.panNumber}
                    sx={{ mt: 2 }}
                    label="PAN"
                    name="panNumber"
                    size="small"
                    fullWidth
                    inputProps={{
                        pattern: "^[A-Z]{5}[0-9]{4}[A-Z]{1}$",
                        title: "Pan Number is invalid",
                        maxLength: 10,
                    }}
                    error={!isValidPan(state.panNumber) && state.panNumber !== "" && state.panNumber !== null && state.panNumber !== undefined}
                    helperText={(!isValidPan(state.panNumber) && state.panNumber !== "" && state.panNumber !== null && state.panNumber !== undefined) && 'Invalid PAN Number'}
                />
            </Box>
            <SafeTextField
                sx={{ mt: 2 }}
                onChange={handleChange}
                value={state.fullName}
                label="Legal Name of The Business"
                size="small"
                name="legalName"
                fullWidth
                inputProps={{ maxLength: 100, minLength: 3 }}
            />
            <SafeTextField
                required
                sx={{ mt: 2 }}
                onChange={handleChange}
                value={state.tradeName}
                label="Trade Name of The Business"
                size="small"
                name="tradeName"
                fullWidth
                inputProps={{ maxLength: 100, minLength: 3 }}
            />
            <TextField
                sx={{ mt: 2 }}
                variant="outlined"
                size="small"
                fullWidth
                select
                onChange={handleChange}
                value={state.category ?? ""}
                InputLabelProps={{ shrink: true }}
                required
                name="category"
                label="Constitution of business"
            >
                {client_categories.map((item, index) => (
                    <MenuItem key={index} value={item.value}>
                        {item.label}
                    </MenuItem>
                ))}
            </TextField>
            <DesktopDatePicker
                label="Effective Date Of Registration"
                inputFormat="dd-MM-yyyy"
                value={state?.registrationDate ? moment(state?.registrationDate, 'DD/MM/YYYY').toDate() : null}
                maxDate={moment().toDate()}
                onChange={(value) => {
                    setState({
                        ...state,
                        registrationDate: moment(value).format("DD/MM/YYYY"),
                    });
                    handleSelect();
                }}
                open={isDatePickerOpen}
                renderInput={(params) => <TextField
                    sx={{ mt: 3 }}
                    required
                    fullWidth
                    size="small"
                    {...params}
                    onKeyDown={handleKeyDown}
                    onClick={() => { setIsDatePickerOpen(true); }}
                    onFocus={handleFocus}
                />}
            />
            <TextField
                variant="outlined"
                size="small"
                sx={{ mt: 2 }}
                fullWidth
                select
                value={state.showDiscount}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                required
                name="showDiscount"
                label="Need Discount Column"
            >

                <MenuItem key={1} value={'true'}>
                    Yes
                </MenuItem>
                <MenuItem key={2} value={'false'}>
                    No
                </MenuItem>

            </TextField>

            <LoadingButton
                onClick={handleSubmit}
                variant="contained"
                color="secondary"
                fullWidth
                sx={{ mt: 3 }}
                loading={isLoading}
                disabled={isLoading}
                title="Submit"
            />
        </>
    );
};
export default PanDetails;
